import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { AiReviewItem, EAiReviewStatus } from "../../aiReview.types";
import { ApiRoutesAiReview } from "../../constants/enums";

export interface UpdateReviewItemBody {
  id: string;
  status: EAiReviewStatus;
  // Only with "reviewed": the lesson the reply led to.
  lessonId?: string;
}

// V3: handle an item ("reviewed", "dismissed") or put it back ("open").
export const requestUpdateReviewItem = async ({
  id,
  ...body
}: UpdateReviewItemBody): Promise<AiReviewItem> =>
  await instance.patch(buildUrl(ApiRoutesAiReview.Root, id), body);
